module.exports = __webpack_public_path__ + "img/5-1.0fe0053d.png";